import normalizeHeight from '@fr/normalize-height';
import { initSyncedCarousel } from '@fr/carousel';

// On document ready
$(function() {

	if( ! document.querySelector('.management-display') ) {
		return;
	}

  // Synchronize the carousels.
  initSyncedCarousel(
    $('.js-management-carousel__display'),
    $('.js-management-carousel__nav')
  );

  // Normalizes the company value boxes to be the same height.
  normalizeHeight($('.js-company-value'));

  /**
   * The about-us__success-story--background provides an opaque background to
   * the text and extends past the grid to the right hand side of the screen.
   *
   * 1. Select the divs.
   * 2. Set the left attribute of the background to be equal to the position of
   *    the left of the text.
   * 3. Calculate the end of the window and set the right attribute of the
   *    background div to (window Length - text div left).
   * 4. In case the user resizes or zooms, recalculate.
   */

  /* [1] */
  var $text = $('.about-us__success-story__text');
  var $background = $('.about-us__success-story__background');

  $background.css('left', + $text.offset().left); /* [2] */
  $background.css('width', + $(window).width() - $text.offset().left); /* [3] */

  // [4]
  $(window).resize(function() {

    $background.css('left', + $text.offset().left); /* [2] */
    $background.css('width', + $(window).width() - $text.offset().left); /* [3] */
  });


});
